import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            五大内容板块，覆盖同人创作的各个领域，总有一个是你心之所向
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading font-semibold text-sm md:text-base text-foreground-800 mb-1 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.count} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}